import { render } from "./TerminalGuard.vue?vue&type=template&id=46827ebd&scoped=true&ts=true"
import script from "./TerminalGuard.vue?vue&type=script&lang=ts"
export * from "./TerminalGuard.vue?vue&type=script&lang=ts"

import "./TerminalGuard.vue?vue&type=style&index=0&id=46827ebd&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46827ebd"]])

export default __exports__